import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle, Dumbbell, ArrowRight, Youtube, Linkedin } from "lucide-react";
import { postNewsletter } from "../lib/api";
import { toast } from "sonner";

const WHATSAPP = "919324404572";
const INSTAGRAM_URL = "https://www.instagram.com/manav.fitcoach";
const YOUTUBE_URL = "https://www.youtube.com/@manav.fitcoach";
const LINKEDIN_URL = "https://www.linkedin.com/in/manav-shah-7b7a1540b";
const EMAIL = "manavfitcoach@gmail.com";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await postNewsletter({ email });
      toast.success("You're in! Welcome to the inner circle.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="relative border-t border-border bg-card/40 pt-20 pb-10 mt-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <span className="w-9 h-9 rounded-full bg-accent flex items-center justify-center">
                <Dumbbell className="w-5 h-5 text-white" />
              </span>
              <span className="font-heading font-black text-lg uppercase">Manav<span className="text-accent">Fitcoach</span></span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-xs leading-relaxed">
              Premium online fitness coaching for busy professionals. Transform your body without guesswork.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-accent font-bold mb-4">Explore</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              {[["/coaching","Coaching"],["/pricing","Pricing"],["/transformations","Results"],["/testimonials","Testimonials"]].map(([to,l])=>(
                <li key={to}><Link to={to} className="hover:text-accent transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-accent font-bold mb-4">Resources</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              {[["/blog","Blog"],["/resources","Free Tools"],["/about","About"],["/contact","Contact"]].map(([to,l])=>(
                <li key={to}><Link to={to} className="hover:text-accent transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-accent font-bold mb-4">Join the Newsletter</h4>
            <p className="text-sm text-muted-foreground mb-4">Weekly training & nutrition tips. No fluff.</p>
            <form onSubmit={subscribe} className="flex items-center gap-2">
              <input
                data-testid="newsletter-input"
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="flex-1 bg-transparent border border-border rounded-full px-4 py-2.5 text-sm outline-none focus:border-accent transition-colors"
              />
              <button data-testid="newsletter-submit" disabled={loading}
                className="w-11 h-11 shrink-0 rounded-full bg-accent text-white flex items-center justify-center hover:scale-105 transition-transform">
                <ArrowRight className="w-4 h-4" />
              </button>
            </form>
            <div className="flex items-center gap-3 mt-6">
              <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:text-accent transition-colors"><MessageCircle className="w-4 h-4" /></a>
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:text-accent transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href={YOUTUBE_URL} target="_blank" rel="noreferrer" aria-label="YouTube" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:text-accent transition-colors"><Youtube className="w-4 h-4" /></a>
              <a href={LINKEDIN_URL} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:text-accent transition-colors"><Linkedin className="w-4 h-4" /></a>
              <a href={`mailto:${EMAIL}`} aria-label="Email" className="w-10 h-10 rounded-full glass flex items-center justify-center hover:text-accent transition-colors"><Mail className="w-4 h-4" /></a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Manav Fit Coach. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-accent transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-accent transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
